import React, {Fragment} from 'react';
import Overlay from 'Components/Overlay';
import Cx from 'classnames';
import Input from "Components/Input";
const ConfirmationPopup = (props)=>(
   
    <Fragment>
        <Overlay>
            
            <div className="bg-white box-shadow ph-20 pv-20 br-5">
                <div className={Cx("mb-10 tCenter fSemibold", {
                    'error-color fs-16': props.isTextErrorColor,
                    'header-medium-color fs-18': !props.isTextErrorColor
                })}>
                    {props.text}
                </div>

                { props && (props.companyId ==="737" || props.hasRemarks) && 
                    <div>
                        <div className="mb-10 tCenter header-medium-color fSemibold fs-14">
                           {props.name}
                        </div>
                        <div className="mt-5 mb-10 tCenter header-medium-color fSemibold fs-18 mt-10">
                          <textarea 
                                style={{ width: '90%',  height: '49px' }}
                                className={"border-status-bar br-3"}
                                name="loiRejectionReason"
                                placeholder={props.placeholder || "Loi Rejection Reason"}
                                value={props.loiRejectionReason}
                                onChange={(e) => props.onChangeLoiRejectionRemarks(e)}
                            />
                        </div>
                    </div>
                }

                {props && props.companyId ==="737" && props.tripCounter && <div>
                    <div className="tCenter header-medium-color fSemibold fs-14">
                        {'Counter'}
                    </div>
                    <div className="mb-10 tCenter header-medium-color flex fSemibold fs-18 mt-5">
                        <div className="mt-10 mr-5">₹</div><Input
                            value={props.counter}
                            onChange={(e) => props.onChangeCounterPrice(e)}
                            placeholder={"Counter Price"}
                            className="tCenter wt-235"
                        />
                    </div>
                </div>
                }

                {props.isNote && 
                <div className="mt-5 mb-5 fs-14">
                    <span className="error-color fBold"> Please Note: </span>
                    <span className="fSemibold">{props.noteText}</span>
                </div>
                }

                <div className="col-1 ht-60 flex flex-middle flex-center bg-white">
                    <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={props.onCancel}>Cancel</button>
                    { props && props.companyId ==="737" ? <button className={(!props.loiRejectionReason)? 'ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30  inputDisabled' :'ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30'} disabled={!props.loiRejectionReason} onClick={props.onConfirm}>Confirm</button>:
                    props.onConfirm &&<button className={Cx("ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30", {'inputDisabled': props.remarksMandatory && !props.loiRejectionReason })}  onClick={props.onConfirm}>Confirm</button>}
                </div>
            </div>    
        </Overlay> 
    </Fragment>
);

export default ConfirmationPopup;